<template>
  <div class="container-fluid pt-0 row mx-0 bg-primary">
    <article class="card col-lg-10 mx-auto my-4">
      <div class="card-body">
        <page-breadcrumb :items="crumbs" />
        <h1 class="h3 card-title">{{ news.title || "新闻详情" }}</h1>
        <p v-if="loadError" class="text-muted">
          暂时无法打开这篇新闻。请返回
          <router-link to="/companynews">公司新闻</router-link>
          或阅读
          <router-link to="/about">公司简介</router-link>
          。
        </p>
        <div v-else class="card-text overflow-hidden" v-html="news.content"></div>
        <p v-if="news.publish" class="card-text fs-6 fw-lighter">
          发布于
          <span class="text-muted">{{ news.publish }}</span>
        </p>
      </div>
    </article>
  </div>
</template>

<script>
import axios from "axios";
import { PAGES, applyHead } from "@/seo/site";

/**
 * 公司新闻详情。数据来自后台，接口不可用时显示静态说明。
 */
export default {
  name: "newsdetail",
  data: function () {
    return {
      crumbs: PAGES.newsdetail.crumbs,
      news: {},
      loadError: false,
    };
  },
  mounted: function () {
    axios
      .get(this.$backend_url + "thenews/" + this.$route.params.id, {
        timeout: 8000,
      })
      .then((res) => {
        const mynewsdata = res.data && res.data[0];
        if (!mynewsdata) {
          this.loadError = true;
          return;
        }
        const time = new Date(mynewsdata.fields.publish);
        this.news = {
          id: mynewsdata.pk,
          title: mynewsdata.fields.title,
          author: mynewsdata.fields.author,
          content: mynewsdata.fields.content,
          publish: time.toLocaleString("zh-CN"),
          datePublished: mynewsdata.fields.publish,
        };
        const plain = String(mynewsdata.fields.content || "")
          .replace(/<[^>]+>/g, "")
          .replace(/\s+/g, "")
          .slice(0, 90);
        applyHead(
          Object.assign({}, PAGES.newsdetail, {
            path: this.$route.path,
            title: mynewsdata.fields.title + "-桂运宝公司新闻",
            description: plain || PAGES.newsdetail.description,
            article: {
              headline: mynewsdata.fields.title,
              datePublished: mynewsdata.fields.publish,
              author: mynewsdata.fields.author || "广西桂运宝科技有限公司",
            },
          })
        );
      })
      .catch(() => {
        this.loadError = true;
      });
  },
};
</script>
